import axios from 'axios'

const wordpress = axios.create({
    baseURL: 'https://cms.tikkl.nl/wp-json/better-rest-endpoints/v1/',
    withCredentials: false,
    timeout: 30000
});

export default wordpress